import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {
public bodyBlocks = [];
  constructor() { }

  ngOnInit() {
    const countBlocks = Math.round(window.innerHeight / 1000);
    this.bodyBlocks = Array.from(Array(countBlocks).keys());
  }

}
